import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00347 = new TileLayer({
  title: 'Máscara 19950909',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19950909l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00347.setVisible(false);

const layer00346 = new TileLayer({
  title: 'Máscara 19960522',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19960522l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00346.setVisible(false);

const layer00345 = new TileLayer({
  title: 'Máscara 19960623',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19960623l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00345.setVisible(false);

const layer00344 = new TileLayer({
  title: 'Máscara 19960709',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19960709l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00344.setVisible(false);

const layer00343 = new TileLayer({
  title: 'Máscara 19960810',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19960810l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00343.setVisible(false);

const layer00342 = new TileLayer({
  title: 'Máscara 19960826',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19960826l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00342.setVisible(false);

export const grupoCapa01_26 = new LayerGroup({
  title: 'Ciclo Hidrológico 1995-1996',
  fold: 'close',
  layers: [layer00342, layer00343, layer00344, layer00345, layer00346, layer00347]
});